import React, { Component, useContext, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { LoginContext } from './../contexts/constant/ActionTypes';

export default function(ComposedClass, reload, adminRoute=false){

	const AuthCheck = (props) => {
		const loginContext = useContext(LoginContext);
		const cookies = new Cookies();
		const cookiesData = cookies.getAll();

		useEffect(() => {
			const { auth } = cookiesData;

			if (loginContext.authLogin) {
				if(reload && !auth) {
					props.history.push('/login');
				} else if(!reload && auth) {
					if (loginContext.loginDetails.type !== 'P' && !adminRoute) {
						props.history.push('/course');
					} else if (loginContext.loginDetails.type !== 'P' && adminRoute) {
						props.history.push('/course');
					} else if (loginContext.loginDetails.type === 'P' && adminRoute) {
						props.history.push('/dashboard');
					} else if (loginContext.loginDetails.type === 'P' && !adminRoute) {
						props.history.push('/dashboard');
					}
				} else if(reload && auth) {
					if (loginContext.loginDetails.type === 'P' && adminRoute) {
						props.history.push('/dashboard');
					} else if (loginContext.loginDetails.type !== 'P' && !adminRoute) {
						props.history.push('/course');
					}
				}
			} else {
				if(reload && !auth) {
					props.history.push('/login');
				}
			}
		}, [loginContext.authLogin]);

		useEffect(() => {
			window.scrollTo(0, 0);
		}, []);
		
		return (
			<ComposedClass {...props} />
		);
	}
	return AuthCheck;
}


// WEBPACK FOOTER //
// ./routes/Auth.js